import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Button, Icon } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { AvatarCropper } from 'lib-accounts-react-avatar-cropper';
import { createRef, PureComponent } from 'react';
import { ConfirmModal } from '../../confirmModal/components/confirmModal';
import CropUpload from '../../crop/CropUpload';
import styles from '../styles/avatarControl.module.scss';
export default class AvatarControl extends PureComponent {
    constructor(props) {
        super(props);
        this.changeAvatar = () => {
            if (this.inputRef.current && this.inputRef.current.fileInput.current) {
                const input = this.inputRef.current.fileInput.current;
                input.click();
            }
        };
        this.handleFileChange = this.handleFileChange.bind(this);
        this.handleRequestHide = this.handleRequestHide.bind(this);
        this.handleCrop = this.handleCrop.bind(this);
        this.deleteAvatar = this.deleteAvatar.bind(this);
        this.changeAvatar = this.changeAvatar.bind(this);
        this.confirmDeleteAvatar = this.confirmDeleteAvatar.bind(this);
        this.hideConfirm = this.hideConfirm.bind(this);
        this.inputRef = createRef();
        this.state = {
            isConfirmDeleteOpen: false,
            cropperOpen: false,
            img: null,
        };
    }
    handleFileChange(dataURI) {
        this.setState({
            img: dataURI,
            cropperOpen: true,
        });
    }
    handleRequestHide() {
        this.setState({ cropperOpen: false });
    }
    handleCrop(dataURI) {
        this.setState({
            cropperOpen: false,
            img: null,
        });
        if (this.props.onSelectAvatar) {
            this.props.onSelectAvatar(dataURI);
        }
    }
    deleteAvatar() {
        var _a, _b;
        (_b = (_a = this.props).onDeleteAvatar) === null || _b === void 0 ? void 0 : _b.call(_a);
        this.hideConfirm();
    }
    hideConfirm() {
        this.setState({
            isConfirmDeleteOpen: false,
        });
    }
    confirmDeleteAvatar() {
        this.setState({
            isConfirmDeleteOpen: true,
        });
    }
    shouldRenderDeleteModal() {
        var _a;
        return !!(((_a = this.props.user) === null || _a === void 0 ? void 0 : _a.avatar_url) && this.props.onDeleteAvatar);
    }
    render() {
        const { user, className, type } = this.props;
        const avatarType = type === 'org' ? 'logo' : 'avatar';
        const rootClass = classnames(styles.avatarRow, className);
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsxs("div", Object.assign({ className: styles.avatarPhotoHolder }, { children: [_jsxs("div", Object.assign({ className: styles.avatarPhoto }, { children: [_jsx(CropUpload, { ref: this.inputRef, handleFileChange: this.handleFileChange }), _jsx("div", Object.assign({ className: styles.avatarEdit }, { children: _jsx(Icon, { name: "plus", className: styles.icon }) })), _jsx(Avatar, { user: user })] })), this.state.cropperOpen === true && (_jsx(AvatarCropper, { onRequestHide: this.handleRequestHide, cropperOpen: this.state.cropperOpen, onCrop: this.handleCrop, image: this.state.img || '' }))] })), _jsx(Button, Object.assign({ variant: "secondary", className: styles.avatarRowButton, onClick: this.changeAvatar }, { children: (user === null || user === void 0 ? void 0 : user.avatar_url) ? `Change ${avatarType}` : `Upload ${avatarType}` })), this.shouldRenderDeleteModal() && (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ variant: "secondary", className: styles.avatarRowButton, onClick: this.confirmDeleteAvatar }, { children: `Reset ${avatarType}` })), _jsx(ConfirmModal, { isShown: this.state.isConfirmDeleteOpen, headline: "Are you sure?", text: `Are you sure you want to reset the ${avatarType}?`, confirmText: "Yes, reset it now", cancelText: "Cancel", confirm: this.deleteAvatar, cancel: this.hideConfirm })] }))] })));
    }
}
AvatarControl.defaultProps = {
    type: 'user',
};
